import { getExtensionVideoFile } from './getExtensionVideoFile';

const generateRandomName = () => Math.random().toString(36).substr(2, 9);

const createFileName = (originalName, orderID) => {
  const fileExtension = originalName.split('.').pop();
  const sanitizedOriginalName = originalName.replace(/[^a-zA-Z0-9.]/g, '').split('.')[0];
  const randomName = generateRandomName();

  // No longer using the title in the filename.
  return `${sanitizedOriginalName}-${randomName}.${fileExtension}`;
};

const createFile = (blob, name, type) => new File([blob], name, { type });

export const getNewFile = async (actualFile, orderID) => {
  const { name: originalFileName, type: fileType } = actualFile.file;

  const newFileName = createFileName(originalFileName, orderID);
  const isVideoFile = await getExtensionVideoFile(newFileName);

  // Create the file without the title as part of its name.
  let newFile = createFile(actualFile.file, newFileName, fileType);

  /* The below code is prepared for potential future use where resizing might be necessary.
  // Uncomment the following lines when ready to use the resize functionality.
  newFile = await attemptResizeFile(newFile, isVideoFile, fileType);
  */

  return {
    newFileName,
    fileType,
    newFile,
    isVideoFile,
  };
};

// Note: The resizeFile logic is kept commented out as it's mentioned it might be used in the future.
